/* src/app/shared/components/reasons-dialog/reasons-dialog.component.scss */
.modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
}
.modal {
  background-color: #fff;
  width: 100%;
  text-align: center;
  padding: 20px;
}
.modal-heading {
  font-size: 24px;
  color: #003a71;
}
.modal-content {
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.options-container {
  border: 2px solid #f44336;
  padding: 10px;
  border-radius: 5px;
}
.option-card {
  width: 98%;
  border-radius: 5px;
  padding: 10px;
  margin: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  text-align: left;
}
.option-card:hover {
  background-color: #f5f5f5;
}
.modal-buttons {
  margin-top: 20px;
}
.btn-save,
.btn-cancel {
  padding: 10px;
  margin: 0 10px;
  width: 120px;
  cursor: pointer;
  border: none;
  border-radius: 20px;
  font-size: 14px;
}
.btn-save {
  background-color: #003a71;
  color: #fff;
}
.btn-cancel {
  background-color: #f4f0e5;
}
.btn-save:hover,
.btn-cancel:hover {
  opacity: 0.8;
}
.validation-message {
  padding: 2px;
  color: #f44336;
  font-size: 12px;
}
.spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
.confirmation-message {
  font-size: 12px;
  max-width: 400px;
}
/*# sourceMappingURL=reasons-dialog.component.css.map */
